import React__default, { useRef, useEffect } from 'react';
import styles from '../../components/extras/Snowfall/index.module.scss.js';
function Snowfall(_a) {
  var _b = _a.color,
    color = _b === void 0 ? '#f2f4ff' : _b,
    _c = _a.count,
    count = _c === void 0 ? 100 : _c,
    _d = _a.active,
    active = _d === void 0 ? false : _d;
  var snowflakesContainer = useRef(null);
  useEffect(function () {
    var snowflakes = [];
    var totalSnowflakes = count; // Adjust number for density
    var maxSize = 5; // Max snowflake size
    var minSize = 2; // Min snowflake size
    var animationFrameId = null; // Store the animation frame ID
    var createSnowflake = function () {
      var snowflake = document.createElement('div');
      var size = Math.random() * (maxSize - minSize) + minSize;
      var left = Math.random() * 100;
      var animationDuration = Math.random() * 3 + 2; // Between 2s and 5s
      snowflake.className = styles.snowflake;
      snowflake.style.width = "".concat(size, "px");
      snowflake.style.height = "".concat(size, "px");
      snowflake.style.left = "".concat(left, "vw");
      if (color) {
        snowflake.style.background = color;
      }
      snowflake.style.animationDuration = "".concat(animationDuration, "s");
      if (snowflakesContainer.current) {
        snowflakesContainer.current.appendChild(snowflake);
      }
      // Cleanup when animation is over
      snowflake.addEventListener('animationend', function () {
        if (snowflakesContainer.current) {
          snowflakesContainer.current.removeChild(snowflake);
        }
        snowflakes.splice(snowflakes.indexOf(snowflake), 1);
      });
      snowflakes.push(snowflake);
    };
    var renderSnowflakes = function () {
      if (active && snowflakes.length < totalSnowflakes) {
        createSnowflake();
      }
      if (active) {
        animationFrameId = requestAnimationFrame(renderSnowflakes);
      }
    };
    if (active) {
      renderSnowflakes();
    }
    return function () {
      // Stop the animation frame loop
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      // Cleanup all snowflakes
      snowflakes.forEach(function (snowflake) {
        if (snowflakesContainer.current) {
          snowflakesContainer.current.removeChild(snowflake);
        }
      });
      snowflakes.length = 0; // Clear the array
    };
  }, [active, color, count]);
  return React__default.createElement("div", {
    ref: snowflakesContainer,
    style: {
      position: 'relative',
      zIndex: 9999
    }
  });
}
export { Snowfall as default };
//# sourceMappingURL=index.js.map
